<template>

<div class="reason">

	<div class="reason-title">Reason for recommendation</div>

	<app-text v-if="recommendation.reason.enabled === $constants.recommendation.text.text" :text="recommendation.reason.text" />

	<app-blocks v-if="recommendation.reason.enabled === $constants.recommendation.text.blocks" :text="recommendation.reason.blocks" />

</div>

</template>

<script>

export default {

	props: ['recommendation']

}

</script>

<style scoped>

.reason {
	margin-bottom: 64px;
}

.is-mobile .reason {
	margin-bottom: 32px;
}

.reason-title {
	font-weight: 100;
	font-size: 24px;
	line-height: 26px;
	letter-spacing: 2px;
	color: #343434;
	text-transform: uppercase;
	margin-bottom: 32px;
}

.is-mobile .reason-title {
	font-size: 18px;
	line-height: 18px;
}

</style>